import { CertificateSettings as CertificateSettingsModule } from "../modules/CertificateSettings/CertificateSettings";
const Certificate = () => {
  return <CertificateSettingsModule />;
};

export default Certificate;
